angular.module('app').factory('loyaltyService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/loyaltypoint/");

        return {

            getLevels: function (lang, id) {
                var request = {};
                if (lang){
                    request.lang = lang;
                }
                if (id){
                    request.id = id;
                }
                return restAngular.
                one("get").
                customGET(param(request))
            },
            changeLevel: function (requestData) {
                return restAngular.
                one("change").
                post("", requestData)
            },
            getImages: function (){
                return restAngular.
                one("getAvailableImages").get();
            }
        }
    }
]);